import {
  BackOutlineIcon,
  CloseOutlineIcon,
  ForwardOutlineIcon,
  RefreshOutlineIcon,
} from '@carboncopyco/icons';
import classNames from 'classnames';
import { useContext } from 'react';
import { TooltipBubble } from '../TooltipBubble';
import { TextBase } from '../Typography';
import { NavbarButton } from './NavbarButton';
import { NavbarContext } from './NavbarContext';

export interface NavbarNavigationProps {
  url?: string;
  showNavigationButtons?: boolean;
  disabledBack?: boolean;
  disabledForward?: boolean;
  onBack?: () => void;
  onForward?: () => void;
  onReload?: () => void;
  onStopReload?: () => void;
  isLoading?: boolean;
}

export const NavbarNavigation = ({
  url,
  showNavigationButtons = true,
  onBack,
  onForward,
  onReload,
  onStopReload,
  isLoading,
  disabledBack,
  disabledForward,
}: NavbarNavigationProps) => {
  const { theme: navbarTheme = 'light' } = useContext(NavbarContext);

  return (
    <div className="mx-2.5 flex gap-3 items-center overflow-hidden">
      {showNavigationButtons && (
        <>
          <NavbarButton
            variant="link"
            disabled={disabledBack}
            icon={<BackOutlineIcon />}
            onClick={onBack}
            tooltipMessage="Backward"
          />
          <NavbarButton
            variant="link"
            disabled={disabledForward}
            icon={<ForwardOutlineIcon />}
            onClick={onForward}
            tooltipMessage="Forward"
          />
          {onReload && onStopReload && (
            <>
              {isLoading ? (
                <NavbarButton
                  variant="link"
                  icon={<CloseOutlineIcon />}
                  onClick={onStopReload}
                  tooltipMessage="Stop loading"
                />
              ) : (
                <NavbarButton
                  variant="link"
                  icon={<RefreshOutlineIcon />}
                  onClick={onReload}
                  tooltipMessage="Refresh"
                />
              )}
            </>
          )}
        </>
      )}
      <TooltipBubble
        placement="top"
        title={url}
        disabled={!url}
      >
        <div
          className={classNames(
            'flex flex-1',
            showNavigationButtons ? 'max-w-[220px]' : 'max-w-[252px]'
          )}
        >
          <TextBase
            label={url}
            color={
              navbarTheme === 'dark'
                ? 'text-ds-accent3-100'
                : 'text-ds-natural-600'
            }
            ellipsis
          />
        </div>
      </TooltipBubble>
    </div>
  );
};
